import React from "react";
import {
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { StepperContext } from "../../../stepper/context/StepperContext";
import { StepSubmitter } from "../../../stepper/StepSubmitter";
import { Box, CircularProgress, Container, Typography } from "@mui/material";
import TitleBar from "../../../components/common-components/TitleBar";
import Heade_w7 from "../../../components/itin/w7form/Heade_w7";
import { useDispatch } from "react-redux";
import { createUpdateItinW7 } from "../../../stores/itin";
import { useStepData } from "../../../stepper/UseStepData";
import { useInputHandler } from "../../../stepper/hooks/useInouthandler";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ApiHelperFunction from "../../../api";

import ListLoadingNew from "../../../components/common-components/ListLoadingNew";
import { useLocation, useNavigate, useParams } from "react-router";

const getScrollableParent = (node: HTMLElement | null): HTMLElement | null => {
  while (node && node !== document.body) {
    const overflowY = window.getComputedStyle(node).overflowY;
    if (overflowY === "auto" || overflowY === "scroll") {
      return node;
    }
    node = node.parentElement;
  }
  return document.scrollingElement as HTMLElement;
};

export const Step3 = () => {
  const stepperState = useContext(StepperContext);
  const dispatch = useDispatch();
  const { data } = useStepData();
  const { payload, handleFormChange } = useInputHandler<any>({});
  const { setData } = useInputHandler<any>(data);
  const [loading, setLoading] = useState(false);
  const [capturing, setCapturing] = useState(false);
  const w7WrapperRef = useRef<HTMLDivElement>(null);
  const currentStepIndex = stepperState.currentStepIdx;
  const savedPayload = stepperState.data.get(currentStepIndex) || {};
  const [fileUploads, setFileUploads] = useState<{
    [key: string]: File | null | string;
  }>({
    w7_form: savedPayload.w7_form || "",
  });

  const [w7FormValues, setW7FormValues] = useState<any>({
    ...(data?.data?.extracted_data?.passport ?? {}),
    ...(data?.data?.w7_form_extracted_data ?? {}),
  });
  const [showName, setShowName] = useState(false);
  const [showSurname, setShowSurname] = useState(false);
  const [showDob, setShowDob] = useState(false);
  const [showAddress1, setShowAddress1] = useState(false);
  const [showAddress2, setShowAddress2] = useState(false);
  const [showNoAddressLine, setShowNoAddressLine] = useState(false);
  const [showMiddleName, setShowMiddleName] = useState(false);
  const [showNoAddressLine2, setShowNoAddressLine2] = useState(false);
  useEffect(() => {
    setShowName(true);
    setShowSurname(true);
    setShowMiddleName(true);
    setShowDob(true);
    setShowAddress1(true);
    setShowAddress2(true);
    setShowNoAddressLine(true);
    setShowNoAddressLine2(true);
  }, []);

  const [initialValue, setInitialValue] = useState<string | null>(null);
  const token = localStorage.getItem("user_token");
  const [getLoading, setGetLoading] = useState(true);
  const navigate = useNavigate(); // ✅ Navigation hook
  const location = useLocation();
  const isEditPassport = location.pathname.includes("edit-documents");
  const isEditW7 = location.pathname.includes("edit-w7");
  const isEditMode = isEditPassport || isEditW7;
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setGetLoading(true);
    try {
      const response = await ApiHelperFunction({
        url: `/get-itin-data/?order_id=${id}`,
        method: "GET",
        headers: {
          Authorization: token ? `${token}` : "",
        },
      });
      if (response?.data?.status === 1) {
        const extractedData =
          response?.data?.data?.w7_form_extracted_data.passport;

        const w7FormExtractedData =
          response?.data?.data?.w7_form_extracted_data.w7_form_extracted_data;
        console.log("Extracted Data:", extractedData);

        console.log("Formatted data before setting state:", extractedData);
        setGetLoading(false);

        setW7FormValues({
          ...(response.data?.data?.extracted_data?.passport ?? {}),
          ...(response.data?.data?.w7_form_extracted_data ?? {}),
        });
        if (stepperState.setData) {
          stepperState.setData(currentStepIndex, response.data, true);
        }
      }
    } catch (error) {
      setGetLoading(false);
    } finally {
      setGetLoading(false);
    }
  };

  useEffect(() => {
    console.log("ExtData: ", data);
    const formData = {
      ...(data?.data?.extracted_data?.passport ?? {}),
      ...(data?.data?.w7_form_extracted_data ?? {}),
    };
    if (Object.keys(formData).length) {
      setW7FormValues((prev: any) => ({
        ...formData,
      }));

      setData((prev: any) => ({
        // ...prev,
        w7_form_extracted_data: formData,
      }));
    }
  }, [data]);

  const handleUpdate = (values: any) => {
    console.log("Updating values:", values);
    setW7FormValues((prev: any) => ({
      ...prev,
      ...values,
    }));
    console.log("update fn:", w7FormValues);
    setData((prev: any) => ({
      ...prev,
      w7_form_extracted_data: { ...prev.w7_form_extracted_data, ...values },
    }));

    if (stepperState.setData) {
      stepperState.setData(
        currentStepIndex,
        {
          ...stepperState.data.get(currentStepIndex),
          w7_form_extracted_data: {
            ...stepperState.data.get(currentStepIndex)?.w7_form_extracted_data,
            ...values,
          },
        },
        true,
      );
    }
  };

  // const generatePDF = async (): Promise<Blob> => {
  //   const input: HTMLElement | null = document.getElementById("pdf-content");
  //   if (!input) throw new Error("PDF content not found!");

  //   const canvas = await html2canvas(input, { scale: 2, useCORS: true });
  //   const pdf = new jsPDF("p", "mm", "a4");
  //   pdf.addImage(canvas.toDataURL("image/png"), "PNG", 10, 10, 190, 277);

  //   return pdf.output("blob");
  // };

  // const generatePDF = async (): Promise<Blob> => {
  //   //compressor
  //   const input: HTMLElement | null = document.getElementById("pdf-content");
  //   if (!input) throw new Error("PDF content not found!");

  //   input.style.width = "1535px";
  //   input.style.minWidth = "1535px";
  //   input.style.maxWidth = "1535px";

  //   const canvas = await html2canvas(input, { scale: 2, useCORS: true });

  //   const imgData = canvas.toDataURL("image/jpeg", 0.6);

  //   const pdf = new jsPDF("p", "mm", "a4");
  //   pdf.addImage(imgData, "JPEG", 10, 10, 190, 277);

  //   return pdf.output("blob");
  // };
  const generatePDF = async (): Promise<Blob> => {
    const input: HTMLElement | null = document.getElementById("pdf-content");
    if (!input) throw new Error("PDF content not found!");

    // NOTE: a "font size boost" style tag used to be injected here for the
    // capture — `#pdf-content * { font-size: 101% !important; line-height: 1.4
    // !important }` plus 48pt/20pt overrides for .text-heading/.title-head.
    // That was for the old flow-based W-7 markup. W7Page sets every size
    // explicitly in points, and because the rule targeted every descendant the
    // 101% compounded down the tree while the forced line-height wrecked the
    // measured baselines — so the download never matched the harness. Removed.

    // W7Page lays out at full page width; the screen scale (.w7-screen zoom)
    // has to come off for the capture or html2canvas renders it shrunk. That
    // visibly grows the live element. A fixed-position spinner overlay covers
    // it for the duration (rendered below) — same treatment as the Form 2848
    // capture. Note: this must stay a plain position:fixed overlay and NOT
    // clip the wrapper itself (e.g. via overflow:hidden) — html2canvas
    // respects ancestor overflow clipping, so constraining the live
    // element's ancestor box during capture would crop the rendered canvas
    // instead of just hiding it visually.
    setCapturing(true);

    const prevZoom = input.style.getPropertyValue("zoom");
    input.style.setProperty("zoom", "1");
    input.classList.add("is-capturing");

    await new Promise((resolve) => setTimeout(resolve, 300)); // slightly longer for reflow

    let canvas;
    try {
      // Capture the SHEET, not the wrapper.
      //
      // #pdf-content is `.fixed-width-container.w7-screen`, which the stylesheet
      // pins to `width: auto !important` — so the inline width this used to set
      // never applied, and the wrapper was simply as wide as the content column.
      // Feeding html2canvas that wrapper's scrollWidth/scrollHeight therefore
      // made the canvas as wide as the VIEWPORT whenever the column was wider
      // than the 1800px sheet (a big monitor, or the browser zoomed out). The
      // sheet sat in the top-left of an oversized canvas, and addImage() below
      // then squashed the whole thing into one Letter page — the form came out
      // shrunk into the left of the sheet, at a scale that changed with the
      // window.
      //
      // .w7-page is exactly W7_CAPTURE_WIDTH_PX x 791.968pt at every viewport,
      // so measuring it is measuring the page. Same options as the Form 2848
      // capture in step4.tsx, which is why that one was never affected.
      const page =
        (document.getElementById("pdf-content-page-1") as HTMLElement | null) ??
        (input.querySelector(".w7-page") as HTMLElement | null) ??
        input;
      canvas = await html2canvas(page, {
        scale: 2,
        useCORS: true,
        logging: false,
      });
    } finally {
      input.classList.remove("is-capturing");
      if (prevZoom) input.style.setProperty("zoom", prevZoom);
      else input.style.removeProperty("zoom");
      setCapturing(false);
    }

    // US Letter, the Form W-7 sheet. W7Page is laid out at exactly
    // 611.976 x 791.968pt with the official's margins inside the artwork, so it
    // maps onto ONE PDF page 1:1 and edge-to-edge. It was previously sliced
    // onto A4, where the aspect mismatch pushed a sliver onto a blank page 2.
    const PAGE_W_MM = 215.9;
    const PAGE_H_MM = 279.4;
    const pdf = new jsPDF("p", "mm", "letter", true);
    pdf.addImage(
      canvas.toDataURL("image/png"),
      "PNG",
      0,
      0,
      PAGE_W_MM,
      PAGE_H_MM,
      undefined,
      "FAST",
    );

    return pdf.output("blob");
  };

  console.log(payload, "payload, payload");

  const mergePayload = async () => {
    const pdfBlob = await generatePDF();

    console.log("Payload: ", payload);

    const pdfFile = new File([pdfBlob], "document.pdf", {
      type: "application/pdf",
    });

    const sizeInKB = (pdfFile.size / 1024).toFixed(2);
    const sizeInMB = (pdfFile.size / (1024 * 1024)).toFixed(2);
    console.log(`📄 Compressed PDF Size: ${sizeInKB} KB (${sizeInMB} MB)`);

    console.log("📂 Converted File:", pdfFile);

    const filteredW7Data = Object.fromEntries(
      Object.entries(w7FormValues).filter(
        ([key, value]) => value !== null && value !== "",
      ),
    );
    setInitialValue(w7FormValues);

    const apiPayload = {
      w7_form_extracted_data: {
        ...filteredW7Data,
        ...payload,
        received: filteredW7Data?.relationshipToApplicant || false,
      },
      w7_form: pdfFile,
      order_id: id,
      ...(isEditMode && { is_updating: "yes" }),
    };

    return apiPayload;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setShowMiddleName(false);
    setShowName(false);
    setShowSurname(false);
    setShowDob(false);
    setShowAddress1(false);
    setShowAddress2(false);
    setShowNoAddressLine(false);
    setShowNoAddressLine2(false);

    try {
      const pdfBlob = await generatePDF();

      console.log("Payload: ", payload);
      console.log("📄 PDF Blob:", pdfBlob);

      const pdfFile = new File([pdfBlob], "document.pdf", {
        type: "application/pdf",
      });

      const apiPayload = await mergePayload();

      console.log("🚀 Sending API Payload:", apiPayload);

      await dispatch<any>(createUpdateItinW7(apiPayload)).unwrap();

      // if (stepperState.setActiveStep) {
      //   stepperState.setActiveStep(stepperState.currentStepIdx + 1, true);
      // }

      if (isEditMode) {
        navigate(`/itin-detail/${id}`);
      } else {
        if (stepperState.setActiveStep) {
          stepperState.setActiveStep(stepperState.currentStepIdx + 1, true);
        }
      }
      if (Object.keys(payload).length <= 0) {
        if (stepperState.setActiveStep) {
          stepperState.setActiveStep(stepperState.currentStepIdx + 1, true);
        }
        setLoading(false);
        return;
      }
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollableParent = getScrollableParent(rootRef.current);
    if (scrollableParent) {
      scrollableParent.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [stepperState.currentStepIdx]);

  return getLoading ? (
    <ListLoadingNew />
  ) : (
    <div ref={rootRef}>
      <TitleBar />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          // paddingTop: 3,
          // paddingBottom: 3,
          padding: 3,
        }}
      >
        <form onSubmit={handleSubmit} onChange={handleFormChange}>
          <Box ref={w7WrapperRef} sx={{ position: "relative" }}>
            <Heade_w7
              option={w7FormValues}
              setFormValues={handleUpdate}
              showAddress1={showAddress1}
              showAddress2={showAddress2}
              showDob={showDob}
              showName={showName}
              showSurname={showSurname}
              showNoAddressLine={showNoAddressLine}
              showMiddleName={showMiddleName}
              showNoAddressLine2={showNoAddressLine2}
              getLoading={getLoading}
            />
            {capturing && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  bottom: 0,
                  // only covers the content column to the right of the
                  // sidebar, not the full viewport, so it stays visible
                  left: w7WrapperRef.current?.getBoundingClientRect().left ?? 0,
                  right: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                  bgcolor: "#fff",
                  zIndex: 1300,
                }}
              >
                <CircularProgress />
                <Typography variant="body1" color="text.secondary">
                  Preparing your form…
                </Typography>
              </Box>
            )}
          </Box>

          <StepSubmitter
            label={"Next"}
            showPrevious={true}
            showNext={true}
            loading={loading}
          />
        </form>
      </div>
    </div>
  );
};

export default Step3;
